import styled from 'styled-components'

const Container = styled.div<Container.Props>`
  border-radius: ${props => props.show ? '24px 16px 16px 16px;' : '24px'};
  max-width: 200px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  position: fixed;
  bottom: 8px;
  left: 8px;
  background-color: ${props => props.theme.cores.WHITE};
  z-index: 1;
  box-shadow: 0px 2px 8px rgba(19, 26, 45, 0.2);
  > svg {
    ${props => !props.show && 'cursor: pointer;'}
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    bottom: 40px;
    left: 40px;
  }
`
namespace Container {
  export interface Props {
    show: boolean
  }
}

export { Container }
